// Подписи статусов заказа на витрине («Мои заказы», трекинг).
// Живут в коде, как и в админке (admin/src/orderStatus.js): настройку подписей заводили
// 20.09.2026 и убрали 23.09.2026 по решению юзера — клиент настраивает только тексты писем
// («Настройки → Статусы»). Набор статусов задаёт система.
// «На упаковке» (packaging) покупателю не показывается: в «Моих заказах» у него нет своей
// строки (fallback на «Новый»), в трекинге шага нет (trackingSteps.js). Самовывоз отличается
// путём заказа: у него нет шага «У курьера» — см. trackingSteps.

export const ORDER_STATUS_LABELS = Object.freeze({
  new: 'Новый',
  packaging: 'На упаковке',
  ready: 'Собран',
  courier: 'У курьера',
  completed: 'Завершён',
  cancelled: 'Отменён',
});
